module.exports = __webpack_public_path__ + "static/media/insuranceBadge.112b420d.svg";